<template>
  <v-dialog
    :model-value="paymentDialog"
    fullscreen
    persistent
    :overlay="false"
    transition="dialog-transition"
  >
    <!-- <v-card elevation="2">
      <v-row
        align="center"
        justify="center"
        :style="{ height: `${VuetifyObj.height}px` }"
        no-gutters
      >
        <v-col cols="12" class="text-center">
          <v-icon
            class="mb-5"
            color="success"
            icon="mdi-check-circle"
            size="112"
          ></v-icon>

          <v-card>
            <v-card-text>
              <v-img
                :width="500"
                aspect-ratio="16/9"
                cover
                eager
                lazy-src
                :src="payment_details.qr_code_url"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card> -->
    <v-container fluid class="d-flex justify-center align-center fill-height">
      <v-card
        :width="400"
        class="pa-4"
        elevation="4"
        style="border-radius: 16px"
      >
        <div v-if="JSON.stringify(payment_details) == '{}'">
          <v-card
            height="300"
            elevation="0"
            class="d-flex align-center justify-center"
          >
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <div class="text-center text-h6">Currently not Available</div>
                  <div class="text-center text-h6">Coming Soon</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
        <div v-else>
          <!-- Title -->
          <div class="text-center mb-2">
            <h3 class="text-h6 font-weight-medium">Scan to Pay</h3>
            <p class="text-primary font-weight-bold">
              {{ payment_details.banking_name }}
            </p>
            <p class="text-primary font-weight-bold">{{ payment_details.upi_id }}</p>
          </div>

          <!-- QR IMAGE -->
          <div class="d-flex justify-center">
            <v-img
              width="200"
              height="300"
              eager
              lazy-src
              :src="payment_details.qr_code_url"
              class="rounded"
            ></v-img>
          </div>
        </div>

        <!-- Buttons -->
        <div class="text-center mt-4">
          <v-btn color="primary" class="mr-2" @click="paymentDialogEmit">
            close
          </v-btn>
        </div>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    paymentDialog: Boolean,
    VuetifyObj: Object,
    payment_details: Object,
  },
  methods: {
    paymentDialogEmit() {
      this.$emit("clicked");
    },
  },
};
</script>
